import classNames from "classnames";
import React, { useId } from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";

import { Spinner } from "../Spinner/spinner.component";
import "./pagination.scss";

type PaginationComponentProps = {
    statusText: string;
    currentNumberOfHits: number;
    totalNumberOfHits: number;
    hitsToLoad: number;
    loading: boolean;
    onClick: () => void;
    className?: string;
};

const PaginationComponent = ({
    statusText,
    currentNumberOfHits,
    totalNumberOfHits,
    hitsToLoad,
    loading,
    onClick,
    className,
}: PaginationComponentProps) => {
    const { t } = useGranite();

    const progressBarId = useId();

    return (
        <section className={classNames("pagination", className)}>
            <div>
                <label
                    htmlFor={progressBarId}
                    className={"pagination__label mb-2"}
                    dangerouslySetInnerHTML={{ __html: statusText }}
                ></label>
                <progress
                    id={progressBarId}
                    className={"pagination__progress-bar w-100"}
                    max={totalNumberOfHits}
                    value={currentNumberOfHits}
                    aria-valuemin={0}
                    aria-valuemax={totalNumberOfHits}
                    aria-valuenow={currentNumberOfHits}
                />
                {currentNumberOfHits < totalNumberOfHits && (
                    <Button
                        className={"pagination__button mt-2"}
                        type="button"
                        onClick={onClick}
                        color={"gray"}
                        fullWidth={true}
                    >
                        {loading && <Spinner size={"sm"} />}
                        {!loading &&
                            t("search.pagination.loadMore", hitsToLoad)}
                    </Button>
                )}
            </div>
        </section>
    );
};

export { PaginationComponent };
